import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import AssetsManager from '../utils/AssetsManager';
import {OptionsProps} from '../types/components';
import WarningIcon from './WarningIcon';

class Options extends React.Component<OptionsProps, {}> {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        customClassLabel: '',
        customClass: '',
        listGroupClass: 'list-group-borderless'
    };

    onChange = (event, item, id) => {
        const error = this.validateEmpty(item);
        this.props.onChange(item, error, id);
    }

    validateEmpty = value => this.props.required && !value ? ValidateConstant.ERROR_REQUIRED : null;

    renderLabel = (label, id, currentChecked) => {
        const {customClassLabel} = this.props;
        return (
            Array.isArray(label) ?
                (<label className={`custom-control-label text-secondary-lighten-1 ${customClassLabel}`}
                        htmlFor={id}>{label.map((item, index) => index === 0 ? item :
                    <span key={index} className="float-right">{item}</span>)}</label>)
                : (<label
                    className=
                        {`custom-control-label ${customClassLabel} ${currentChecked ? currentChecked : ''}`}
                    htmlFor={id}>
                    {label}
                </label>)
        );
    }

    render() {
        const {
            id, name, label, options, customClass, listGroupClass, required, labelError,
            hasError, orientation, defaultValue, customWrapperClass
        } = this.props;
        const invalidClass = hasError && labelError && 'is-invalid';
        return (
            <div className={`form-group radio-button ${customWrapperClass || ''}`}>
                {label ? <label className="label-radio">{label}{required && <span className="asterisk">*</span>}
                    {hasError && labelError && <span className="ic"><WarningIcon/></span>}
                </label> : ''
                }
                <ul className={`list-group ${listGroupClass} ${orientation ? orientation : ''}`}>
                    {options && options.map((item, index) => {
                        const inputId = `${id}-${index}`;
                        const currentChecked = item.value === defaultValue ? 'checked' : '';
                        return (
                            <li key={index} className="list-group-item">
                                <div className={`${customClass} custom-control custom-radio`}>
                                    <input type="radio"
                                           className={`custom-control-input ${currentChecked}`}
                                           id={inputId}
                                           required={required}
                                           name={name}
                                           value={item.value}
                                           checked={item.value === defaultValue}
                                           onChange={e => this.onChange(e, item, id)}
                                    />
                                    {this.renderLabel(item.label, inputId, currentChecked)}
                                </div>
                            </li>
                        );
                    })}
                </ul>
                <strong id={`${name}Help`} className={`form-text ${invalidClass}`}>
                    {hasError && labelError ? labelError : '\u00A0'}
                </strong>
            </div>
        );
    }
}

export default Options;
